export default __webpack_public_path__ + "static/media/icon-b.6cb664c9.svg";